var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container wizard"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 p-0"},[_c('h2',[_vm._v("Reporte")])])])])
}]

export { render, staticRenderFns }